module.exports = __webpack_public_path__ + "img/anouilh.55c33874.jpg";